import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import {
    getPayrollCompensationRetrieveQueryKey,
    getPayrollOverviewRetrieveQueryKey,
    payrollCompensationSalaryConfirm,
} from 'services/payroll/api/generated/v1/payroll';
import { payrollErrorMessage } from 'services/payroll/api/payrollError';
import reportUnlessApiReported from 'services/payroll/api/reportPayrollError';
import useInvalidateMemberTaskQueries from 'services/memberTasks/useInvalidateMemberTaskQueries';

/**
 * Keeps the owner's current salary. Records the review as a fresh choice and completes the
 * "review your reasonable compensation" task; nothing is sent to the payroll provider.
 */
export default function useConfirmCompensationSalary() {
    const queryClient = useQueryClient();
    const invalidateMemberTasks = useInvalidateMemberTaskQueries();

    return useMutation({
        mutationFn: () => payrollCompensationSalaryConfirm(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: getPayrollCompensationRetrieveQueryKey() });
            queryClient.invalidateQueries({ queryKey: getPayrollOverviewRetrieveQueryKey() });
            // The review task is ungrouped, so every task surface refreshes.
            invalidateMemberTasks({ group_id: null });
        },
        onError: (error) => {
            reportUnlessApiReported(error, {
                source: 'useConfirmCompensationSalary',
            });
            enqueueSnackbar(payrollErrorMessage(error), { variant: 'error' });
        },
    });
}
